/**
 * OAuth initiation URLs + auth helpers.
 *
 * Base URL is same-origin by default. Dev: Vite proxies /oauth2/** to Spring
 * Boot on :8880. Prod: Traefik routes app.merkflow.eu/oauth2/** to the backend.
 * VITE_API_BASE_URL can override this (e.g. running frontend against prod API).
 */
import { useAuthStore } from '@/stores/authStore';

const BACKEND_URL = (import.meta.env.VITE_API_BASE_URL ?? '') as string;

export const getGoogleLoginUrl = () => `${BACKEND_URL}/oauth2/authorization/google`;
export const getLinkedInLoginUrl = () => `${BACKEND_URL}/oauth2/authorization/linkedin`;

export const isAuthenticated = (): boolean => {
  return !!useAuthStore.getState().token;
};

export const logout = () => {
  useAuthStore.getState().logout();
  if (typeof window !== 'undefined') {
    window.location.href = '/login';
  }
};
